(function ($) {

     $(window).on( "load", function() {
        disableSearchButtonC();
         
        var buttonText = $('.CoveoSearchButton').attr('aria-label');
      
        $('.detail-search .CoveoSearchButton').click(function(e) {
            disableSearchButtonC();
        }); 

        $('.detail-search .magic-box-input input').keyup(function () {
		    disableSearchButtonC();
		});
      
        $('.detail-search .magic-box-input input').keypress(function (e) {
            if (e.keyCode == 13) {
                  e.preventDefault();
                  disableSearchButtonC();
            }
         });

         $('.detail-search .magic-box-input input').keydown(function (e) {
             if (e.keyCode == 13) {
                 e.preventDefault();
                 disableSearchButtonC();
                 return false;
             }
         });
    });

    function disableSearchButtonC() {
      $('.detail-search .CoveoSearchbox .CoveoSearchButton').show();
    }

}(window.jQuery));
